const translations = {
  // Header / view badges
  prologueResults: 'RÉSULTATS DU PROLOGUE',
  startPositionSelection: 'SÉLECTION DE POSITION DE DÉPART',
  appTitle: 'APPLICATION DE SÉLECTION DE POSITION DE DÉPART',
  pickOrder: "Ordre de Choix",
  poweredBy: 'Développé par',

  // Toolbar tooltips
  zoomIn: 'Zoom avant',
  zoomOut: 'Zoom arrière',
  configuration: 'Configuration',
  connectingZigbee: 'Connexion…',
  disconnectZigbee: 'Déconnecter Zigbee',
  connectZigbee: 'Connecter Zigbee',
  zigbeeConnectError: 'Échec de la connexion du récepteur Zigbee sans fil',
  zigbeeConnected: 'Récepteur Zigbee sans fil connecté avec succès.',
  zigbeeDeviceNotPaired: "La télécommande n'est pas appairée. Maintenez le bouton HAUT enfoncé pendant 10 secondes jusqu'à ce que la LED clignote. Lorsque la lumière reste fixe, la télécommande est appairée. Temps restant pour appairer :",
  zigbeeDevicePaired: 'Télécommande appairée avec succès et connectée au réseau.',
  zigbeePortInUse: "Le port série est déjà utilisé. Fermez toute autre application qui l'utilise et réessayez.",
  exitEditMode: "Quitter le mode d'édition",
  editParticipants: 'Modifier les participants',
  reset: 'Réinitialiser',
  switchToPrologue: 'Voir les Résultats du Prologue',
  switchToStart: 'Voir la Sélection de Position de Départ',
  stopSession: 'Arrêter la session',
  startSession: 'Démarrer la session',
  sessionStarted: 'Session de sélection de position de départ lancée. Pilotes, choisissez votre position de départ !',
  loadFromAnube: 'Importer depuis Anube',
  addParticipant: 'Ajouter un participant',

  // Session warning dialog
  startNewSession: 'Nouvelle Session',
  sessionWarningBody: 'Des positions ont déjà été attribuées. Démarrer une nouvelle session depuis le début ou continuer celle en cours ?',
  newSession: 'Nouvelle Session',
  continueSession: 'Continuer',

  // DialogConfirm defaults
  resetTitle: "Réinitialiser l'Ordre de Départ",
  resetBody: 'Tous les participants et les données de session seront supprimés définitivement.',
  resetConfirm: 'Tout Supprimer',
  warningCannotBeUndone: 'Cette action est irréversible.',
  cancel: 'Annuler',
  confirm: 'Confirmer',

  // AddParticipantModal / EditParticipantModal shared
  brand: 'Marque',
  driver: 'Pilote',
  driverNamePlaceholder: 'Nom du pilote',
  coDriver: 'Co-Pilote',
  coDriverNamePlaceholder: 'Nom du co-pilote',
  team: 'Équipe',
  teamNamePlaceholder: "Nom de l'équipe",
  allowChooseStart: 'Autoriser le choix de la position de départ',
  priorityPilot: 'Pilote prioritaire',
  timeSec: 'Temps (sec)',

  // AddParticipantModal
  addParticipantTitle: 'Ajouter un Participant',
  add: 'Ajouter',

  // EditParticipantModal
  editParticipantTitle: 'Modifier le Participant',
  save: 'Enregistrer',

  // ConfigModal
  configTitle: 'Configuration',
  eventName: "Nom de l'événement",
  showTime: 'Afficher le temps du participant',
  showCodriver: 'Afficher le co-pilote',
  showTeam: "Afficher l'équipe",
  allParticipantsVisible: 'Tous les participants visibles avant de choisir',
  language: 'Langue',
  close: 'Fermer',

  // RaceConfigModal
  loadFromAnubeTitle: 'Importer depuis Anube',
  raceNumber: 'Numéro de course',
  raceNumberPlaceholder: 'ex. 305',
  loading: 'Chargement…',
  load: 'Charger',
  loadError: 'Échec du chargement. Vérifiez le numéro de course.',
  itinerary: 'Itinéraire',
  specialStage: 'Spéciale / Étape',
  applyAndFetch: 'Appliquer et Charger',

  // Priority pilots field
  priorityPilotsLabel: 'Pilotes prioritaires (par numéro)',
  priorityPilotsPlaceholder: 'ex. 201, 37, 5',
  priorityPilotsHint: 'Liste séparée par des virgules des numéros de véhicule à marquer comme pilotes prioritaires.',

  // Max participants
  maxParticipantsLabel: 'Participants à importer',

  // FIA Rules
  useFiaRules: 'Utiliser les Règles FIA Section 33.1.1',
};

export default translations;